import { PageBreadcrumbsWithLinks } from '@/components'
import { dashboardShellBreadcrumb } from '@/constants/adminPage'
import React, { lazy, useState } from 'react'
import { useTranslation } from 'react-i18next'
import withSuspense from '@/helpers/suspense.helper'
import { PageBody, PageTitle, PageWrapper } from '@/components/PageWrapper'
import type { CustomPlanRequestListItem } from '@/services/customPlanRequestApi'

const ViewCustomPlanRequests = withSuspense(lazy(() => import('./Components/ViewCustomPlanRequests')))
const ActivateCustomPlanRequestModal = withSuspense(lazy(() => import('./Components/ActivateCustomPlanRequestModal')))

const ManageCustomPlanRequests: React.FC = () => {
	const { t } = useTranslation()
	const [selected, setSelected] = useState<CustomPlanRequestListItem | null>(null)

	const pageTitle = t('Manage.CustomPlanRequests.Heading', 'Custom Plan Requests')

	const onActionClick = (request: CustomPlanRequestListItem, action: string) => {
		if (action === 'View') {
			setSelected(request)
		}
	}

	return (
		<>
			<PageBreadcrumbsWithLinks
				title={pageTitle}
				subNames={dashboardShellBreadcrumb(t('Manage.CustomPlanRequests.Breadcrumb', 'Custom Plan Requests'))}
			/>

			<PageWrapper>
				<PageTitle />
				<PageBody>
					<ViewCustomPlanRequests onActionClick={onActionClick} reload={false} />
				</PageBody>
			</PageWrapper>

			{selected && (
				<ActivateCustomPlanRequestModal
					request={selected}
					onClose={() => setSelected(null)}
				/>
			)}
		</>
	)
}

export default ManageCustomPlanRequests
